import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4cd3ca38"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "custom-style-group"
};
const _hoisted_2 = {
  class: "header-warp"
};
const _hoisted_3 = {
  class: "cms-module-title"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "main-brand-list"
};
const _hoisted_6 = {
  class: "main-brand-warp"
};
const _hoisted_7 = {
  class: "main-brand-header"
};
const _hoisted_8 = {
  class: "left-warp"
};
const _hoisted_9 = {
  class: "logo"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-bg"
}, null, -1));

const _hoisted_11 = {
  class: "brand-info"
};
const _hoisted_12 = {
  class: "placeholder-name"
};
const _hoisted_13 = {
  class: "right-warp"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "sub-brand-warp"
};
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
import CustomStyleItem from './customStyleItem.vue';
import { getTextWidth } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'customStyleGroup',
  props: {
    groupItem: {
      type: Object,
      default: null
    }
  },
  emits: ['onEdit', 'onDelete'],

  setup(__props, {
    emit
  }) {
    const props = __props;

    const onEditBtnClick = item => {
      emit('onEdit', item);
    };

    const onDeleteBtnClick = item => {
      emit('onDelete', item);
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = (e, option = {
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'Microsoft YaHei'
    }) => {
      const target = e.target;
      const width = getTextWidth(target.innerText, option);
      tipDisabled.value = target.offsetWidth < width;
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_RecycleScroller = _resolveComponent("RecycleScroller");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.groupItem && __props.groupItem.mainAgentName), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('主品牌')), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_RecycleScroller, {
        items: __props.groupItem && __props.groupItem.agentList || [],
        buffer: 500,
        "page-mode": true,
        "size-field": "size",
        "key-field": "uniqueId",
        "min-item-size": 430
      }, {
        default: _withCtx(({
          item,
          index
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(MyLoadingImage, {
          class: "brand-logo",
          width: "60px",
          height: "60px",
          style: {
            "margin-right": "16px",
            "border-radius": "12px"
          },
          src: item.logo
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.name
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            class: "brand-name",
            onMouseover: _cache[0] || (_cache[0] = $event => showTextTip($event, {
              fontSize: '20px',
              fontWeight: 600,
              fontFamily: 'Microsoft YaHei'
            }))
          }, _toDisplayString(item.name), 33)]),
          _: 2
        }, 1032, ["disabled", "content"]), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('定制名称')), 1)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
          class: "cms-op-btn cms-op-btn-main",
          onClick: $event => onEditBtnClick(item),
          style: {
            "margin-right": "10px"
          }
        }, _toDisplayString(_ctx.$t('编辑')), 9, _hoisted_14), _createElementVNode("div", {
          class: "cms-op-btn cms-op-btn-orange",
          onClick: $event => onDeleteBtnClick(item)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_15)])]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subAgentList || [], (subItem, subIndex) => {
          return _openBlock(), _createBlock(CustomStyleItem, {
            key: subIndex,
            subBrandInfo: subItem
          }, null, 8, ["subBrandInfo"]);
        }), 128))])])]),
        _: 1
      }, 8, ["items"])])]);
    };
  }

});